import { mapMutations, mapGetters, mapActions } from "vuex";
import { maxLength, minLength, required, sameAs } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import legalClientForm from "./components/legal-client/index.vue";

export default {
    name: "add-address-form",
    mixin: [validationMixin],
    components: {
        legalClientForm,
    },
    data() {
        return {
            typeOfClient: true,
            payload: {
                active: false,
                city: "",
                street: "",
                house: "",
                flat: "",
                name: "",
                surname: "",
                lastname: "",
                phone: "",
            },
            showLoader: false,
            validationErrors: {},
            name: "",
            lastName: "",
            patronymic: "",
            email: "",
        };
    },
    validations() {
        if (this.user.agent_status === 2) {
            return {
                payload: {
                    // city: {
                    //     required: false,
                    //     minLength: minLength(1),
                    //     maxLength: maxLength(30),
                    // },
                    // street: {
                    //     required: false,
                    //     minLength: minLength(1),
                    //     maxLength: maxLength(50),
                    // },
                    // house: {
                    //     required: false,
                    //     minLength: minLength(1),
                    //     maxLength: maxLength(8),
                    // },
                    // flat: {
                    //     minLength: minLength(1),
                    //     maxLength: maxLength(8),
                    // },
                    name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    surname: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    phone: {
                        required,
                        minLength: minLength(19),
                    },
                    active: {},
                },
            };
        } else if (this.user.agent_status === 0) {
            return {
                payload: {
                    city: {
                        required: false,
                        minLength: minLength(1),
                        maxLength: maxLength(30),
                    },
                    street: {
                        required: false,
                        minLength: minLength(1),
                        maxLength: maxLength(50),
                    },
                    house: {
                        required: false,
                        minLength: minLength(1),
                        maxLength: maxLength(8),
                    },
                    flat: {
                        minLength: minLength(1),
                        maxLength: maxLength(8),
                    },
                },
            };
        }
    },
    created() {},
    mounted() {},
    computed: {
        ...mapGetters({
            user: "profile/user",
            addAddressLoading: "profile/addAddressLoading",
        }),
        fullNameErrors() {
            let error = [];
            if (!this.$v.payload.fullName.$dirty) {
                return error;
            }
            if (!this.$v.payload.fullName.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.fullName.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.fullName.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.fullName) {
                this.validationErrors.fullName.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        surnameErrors() {
            let error = [];
            if (!this.$v.payload.surname.$dirty) {
                return error;
            }
            if (!this.$v.payload.surname.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.surname.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.surname.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.surname) {
                this.validationErrors.surname.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        lastnameErrors() {
            let error = [];
            if (!this.$v.payload.lastname.$dirty) {
                return error;
            }
            if (!this.$v.payload.lastname.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.lastname.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.lastname.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.lastname) {
                this.validationErrors.lastname.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.phone.minLength) {
                error.push(this.$t("validationLengthPhone"));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        cityErrors() {
            let error = [];
            if (!this.$v.payload.city.$dirty) {
                return error;
            }
            if (!this.$v.payload.city.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.city.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.city.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.city) {
                this.validationErrors.city.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        streetErrors() {
            let error = [];
            if (!this.$v.payload.street.$dirty) {
                return error;
            }
            if (!this.$v.payload.street.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.street.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.street.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.street) {
                this.validationErrors.street.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        houseErrors() {
            let error = [];
            if (!this.$v.payload.house.$dirty) {
                return error;
            }
            if (!this.$v.payload.house.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.house.maxLength) {
                error.push(this.$t("validationMax") + " 8");
            }
            if (!this.$v.payload.house.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.house) {
                this.validationErrors.house.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        flatErrors() {
            let error = [];
            if (!this.$v.payload.flat.$dirty) {
                return error;
            }
            if (!this.$v.payload.flat.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.flat.maxLength) {
                error.push(this.$t("validationMax") + " 8");
            }
            if (this.validationErrors.flat) {
                this.validationErrors.flat.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            return (
                this.payload.city === "" ||
                this.payload.street === "" ||
                this.payload.house === "" ||
                this.payload.flat === ""
            );
        },
        disableActiveCheckbox() {
            return this.userExists();
        },
    },
    methods: {
        ...mapActions({
            addUserAddress: `profile/ADD_USER_ADDRESS`,
            fetchUserData: `profile/FETCH_USER_DATA`,
            addAgentClient: `profile/ADD_NEW_AGENT_CLIENT`,
            fetchAgentClients: `profile/GET_AGENT_CLIENTS`,
        }),
        ...mapMutations({}),
        cancel() {
            this.payload.city = "";
            this.payload.street = "";
            this.payload.house = "";
            this.payload.flat = "";
            this.payload.active = false;
            this.payload.name = "";
            this.payload.surname = "";
            this.payload.lastname = "";
            this.payload.phone = "";
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        submit() {
            this.$v.$touch();
            let obj = {};
            obj.city = this.payload.city;
            obj.active = this.payload.active;
            obj.street = this.payload.street;
            obj.house = this.payload.house;
            obj.flat = this.payload.flat;

            if (!this.$v.$invalid) {
                this.addUserAddress(obj)
                    .then(() => {
                        this.$toasted.success(this.$t("youAddressAdded"));
                        this.fetchUserData();
                        this.cancel();
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            console.log();
                        }
                    });
            }
        },
        agentSubmit() {
            this.$v.$touch();
            let obj = {};
            obj.phone = this.payload.phone.replace(/[\s.,%()-]/g, "");
            obj.name = this.payload.name;
            obj.first_name = this.payload.surname;
            obj.second_name = this.payload.lastname;
            // obj.city = this.payload.city;
            // obj.street = this.payload.street;
            // obj.house = this.payload.house;
            // obj.flat = this.payload.flat;
            obj.type = 1;
            if (!this.$v.$invalid) {
                this.addAgentClient(obj)
                    .then(() => {
                        this.$toasted.success(this.$t("newAgentClientAdded"));
                        this.fetchAgentClients();
                        this.cancel();
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            console.log(error.response.status);
                        }
                    });
            }
        },
        validName(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[a-zA-Zа-яА-я- ]*$/.test(char)) return true;
            else e.preventDefault();
        },
    },
};
